import { destroyGame, PRIVATE_API } from './index';
import { API_ERRORS } from '../../app.config.vars/errorCodes';
import { SAVE_GAME_RESULT_MODAL_COUNT_KEY } from '../../app.config.vars/stored';
const endpoints = {
    gameTasks: '/tasks',
    gameState: '/game-sessions/status',
    gameComplete: '/game-sessions/complete',
    gameAbort: '/game-sessions/abort',
    taskAnswersTimeLogsList: '/task-time-logs',
    taskAnswer: '/player-answer',
    taskAnswersList: '/player-answers',
};
export const getGameTasks = async () => {
    return await PRIVATE_API.GET.all({ endpoint: endpoints.gameTasks });
};
export const getGameState = async () => {
    return await PRIVATE_API.GET.single({ endpoint: endpoints.gameState });
};
export const sendTaskAnswersTimeLogsList = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.taskAnswersTimeLogsList, body });
};
export const sendTaskAnswer = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.taskAnswer, body });
};
export const sendTaskAnswersList = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.taskAnswersList, body });
};
export const sendCompleteGame = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.gameComplete, body });
};
/**
 * Deletes the running game session and everything stored for it on the server, then clears the
 * local game. Local data is kept when the server could not be reached, so the player can retry
 * instead of leaving a half-saved session behind.
 */
export const abortGame = async () => {
    const result = await PRIVATE_API.POST({
        endpoint: endpoints.gameAbort,
        body: {},
        handleInvalidSession: false,
    });
    if (result.error) {
        if (result.error.code === 'no_internet') {
            return 'no_internet';
        }
        // the session no longer exists on the server, so there is nothing left to delete there
        if (result.error.code !== API_ERRORS.invalidGameSession) {
            return 'error';
        }
    }
    sessionStorage.removeItem(SAVE_GAME_RESULT_MODAL_COUNT_KEY);
    await destroyGame();
    return 'aborted';
};
